<div *ngIf="active" class="modal-loading">
  <div class="modal-loading__main">
    <div class="modal-loading__elements mb-8"></div>

    <h1 class="mb-8">Aguarde...</h1>

    <p>Estamos processando suas informações.</p>
  </div>
</div>